import PropTypes from "prop-types";
import React, { Component } from "react";

import Portal from "./Portal";

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.el = React.createRef();
  }

  state = {
    posStyle: {},
    visible: false
  };

  showTooltip = () => {
    const { position } = this.props;
    const el = this.el.current;
    const dimensions = el.getBoundingClientRect();
    const { x, y, height, width } = dimensions;
    let left;
    let top;

    switch (position) {
      case "left":
        left = x;
        top = y + height / 2;
        break;
      case "btm-left":
        left = x;
        top = y + height;
        break;
      case "top-right":
        left = x + width;
        top = y;
        break;
      case "right":
        left = x + width;
        top = y + height / 2;
        break;
      case "btm-right":
        left = x + width;
        top = y + height;
        break;
      case "top-center":
        left = x + width / 2;
        top = y;
        break;
      case "btm-center":
        left = x + width / 2;
        top = y + height;
        break;
      default:
        left = x;
        top = y;
        break;
    }

    // Workaround for tooltips on buttons, because you can't have hover effects
    // on button children in Firefox. Adds button padding to style position
    // https://bugzilla.mozilla.org/show_bug.cgi?id=843003
    if (el.firstElementChild) {
      const computedStyles = window.getComputedStyle(el.firstElementChild);
      left += parseInt(computedStyles["padding-left"], 10);
      top += parseInt(computedStyles["padding-top"], 10);
    }

    const posStyle = { left, top };

    this.setState({ visible: true, posStyle });
  };

  hideTooltip = () => {
    this.setState({ visible: false });
  };

  render() {
    const { posStyle, visible } = this.state;
    const { children, message, position, ...otherProps } = this.props;

    return (
      <span
        onFocus={this.showTooltip}
        onBlur={this.hideTooltip}
        onMouseOver={this.showTooltip}
        onMouseOut={this.hideTooltip}
        ref={this.el}
      >
        {children}
        {visible && (
          <Portal>
            <span
              className={`p-tooltip p-tooltip--${position}`}
              style={posStyle}
            >
              <span className="p-tooltip__message--portal" {...otherProps}>
                {message}
              </span>
            </span>
          </Portal>
        )}
      </span>
    );
  }
}

Tooltip.defaultProps = {
  position: "top-left"
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.node.isRequired,
  position: PropTypes.oneOf([
    "left",
    "right",
    "top-left",
    "btm-left",
    "top-right",
    "btm-right",
    "top-center",
    "btm-center"
  ])
};

export default Tooltip;
